import { guid } from '../common';
import { IOrder } from '../../projects/shopping-cart/cart-thank-you/interfaces';
import { round2DecimalPlaces } from '../math-provider';

/**
 * Allows to TypeScript recognize Impact Radius namespace
 */
declare global {
    interface Window {
        ire: any;
    }
}

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-344
 */
export const impactRadiusCreateAccount = () => {
    if(!window.ire) return;

    window.ire('trackConversion', 17226, {
        orderId: guid().replace(/-/g, ''), // GUID without dashes
        customerId: '',
        customerEmail: '',
    }, {verifySiteDefinitionMatch:true});
};

export const impactRadiusThankYouPage = (orderData: IOrder) => {
    if(!window.ire) return;

    const impactRadiusData = {
        orderId: orderData.wavesReceiptID,
        customerId: orderData.wavesReceiptID,
        customerEmail: '',
        customerStatus: orderData.isOldUser ? 'Returning' : 'New', // : (Required) Use values of “New” or “Returning”. This value can be used to alter payouts. (AlphaNumeric 40)
        currencyCode: 'USD',
        // orderDiscount: orderData.upsellDiscount,
        items: [] as any[],
    };

    if(orderData.orderItems){

        for(let i=0; i<orderData.orderItems.length; i++){
            const item = orderData.orderItems[i];
            impactRadiusData.items.push({
                subTotal: round2DecimalPlaces(item.discountPrice * item.orderItemUnitCount),
                category: item.departmentDisplayName.toLowerCase(),
                sku: item.skuNumber,
                quantity: item.orderItemUnitCount,
            });
        }
    }

    window.ire('trackConversion', 10223, impactRadiusData, {
        verifySiteDefinitionMatch: true
    });
};